export default {
  baseStyle: ({ colorScheme, isInvalid }) => ({
    buttonGroup: {
      display: 'flex',
      gap: '3',
    },
    label: {
      px: 5,
      h: '12',
      fontSize: 'md',
      boxShadow: 'md',
      bgColor: 'white',
      cursor: 'pointer',
      borderRadius: 'xl',
      borderWidth: '1px',
      fontWeight: 'medium',
      borderColor: isInvalid ? 'red.500' : 'gray.400',
      _checked: {
        boxShadow: '0 0 0 0.5px',
        color: `${colorScheme}.500`,
        bgColor: `${colorScheme}.100`,
        borderColor: `${colorScheme}.500`,
      },
    },
  }),
  variants: {
    inline: {
      buttonGroup: {
        gap: '0',
      },
      label: {
        borderRightWidth: '0',
        borderRadius: '0',
        _checked: {
          borderWidth: '1px',
        },
        _first: {
          borderTopLeftRadius: 'xl',
          borderBottomLeftRadius: 'xl',
        },
        _last: {
          borderTopRightRadius: 'xl',
          borderBottomRightRadius: 'xl',
          borderRightWidth: '1px',
        },
      },
    },
    wrap: {
      buttonGroup: {
        flexWrap: 'wrap',
        gap: '1rem',
      },
      label: {
        minWidth: '20',
      },
    },
  },
};
